import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

/**
 * Stan dialogu dokupienia puli elementow (model cenowy 2.0).
 *
 * Sam dialog mieszka nizej w drzewie, bo zeby dokupic pule, potrzebuje klienta lekcji. Ten
 * kontekst trzyma WYLACZNIE stan otwarcia i dlatego moze stac nad obsluga bledow, ktora go
 * otwiera. Bez tego rozdzialu powstalby cykl: obsluga bledow -> dialog -> klient lekcji ->
 * obsluga bledow.
 */
interface ElementPoolContextType {
  isOpen: boolean;
  openTopUp: () => void;
  closeTopUp: () => void;
}

const ElementPoolContext = createContext<ElementPoolContextType | undefined>(undefined);

export function ElementPoolProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const openTopUp = useCallback(() => setIsOpen(true), []);
  const closeTopUp = useCallback(() => setIsOpen(false), []);

  return (
    <ElementPoolContext.Provider value={{ isOpen, openTopUp, closeTopUp }}>
      {children}
    </ElementPoolContext.Provider>
  );
}

export function useElementPool() {
  const context = useContext(ElementPoolContext);
  if (context === undefined) {
    throw new Error('useElementPool must be used within an ElementPoolProvider');
  }
  return context;
}
